<template>
  <v-card-text>
        <v-layout row wrap class="pa-0">
          <v-flex md6 xs12>
            <v-text-field
              :label="$vuetify.lang.t('$vuetify.office_name') + '*'"
              :rules="[rules.required]"
              outlined
              class="pr-3"
              type="text"
              v-model="visa.extra.application_data.diplomatic_mission_name"
            ></v-text-field>
          </v-flex>
          <v-flex md6 xs12>
            <v-text-field
              :label="$vuetify.lang.t('$vuetify.position') + '*'"
              :rules="[rules.required]"
              outlined
              class="pr-3"
              type="text"
              v-model="visa.extra.application_data.position"
            ></v-text-field>
          </v-flex>
        </v-layout>
  </v-card-text>
</template>

<script>
import AddressAutoComplete from "../../AddressAutoComplete";
import { validationMixin } from "../../../mixins/validationMixin";

export default {
  data: () => ({
    rfdialogmodal: false,
    visa_reason: [],
    options: [
      {
        text: "Nepal",
        value: "Nepal"
      },
      {
        text: "Abroad",
        value: "Abroad"
      }
    ]
  }),
  mixins: [validationMixin],

  components: {
    "address-auto-complete": AddressAutoComplete
  },
  computed: {
    visa: {
      get() {
        let v = this.$store.state.VisaSingle.visa;
        return v;
      },
      set(value) {}
    },
    dynamicName: {
      get() {
        const n =
          this.visa.extra.application_data.place_staying === "Hotel"
            ? this.$vuetify.lang.t("$vuetify.hotel")
            : this.$vuetify.lang.t("$vuetify.place");
        return "Name of the " + n;
      },
      set(value) {}
    }
  },
  methods: {
    addressChanged(e) {
      this.visa.extra.application_data.address = e;
    }
  },
  watch: {
    visa_reason: function() {
      this.visa.extra.application_data.visa_reason = this.visa_reason;
    }
  }
};
</script>

<style>
</style>
